import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';

const FixedHeaderStyles = css`
  position: fixed;
  top: 0;
  right: 50%;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 10px;
  transform: translateX(50%);

  @media screen and (min-width: 1280px) {
    max-width: 1340px;
  }
`;

const SelectionHeaderStyles = css`
  width: 100%;
  height: 70px;
  border-radius: 14px;
`;

export const MobileHeader = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  gap: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
`;

export const HeaderBox = styled.div<{ $isFixed: boolean }>`
  z-index: 20;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding-top: 20px;
  background-color: ${({ theme }) => theme.palette.system.white};

  ${({ $isFixed }) => $isFixed && FixedHeaderStyles}
`;

export const HeaderPlaceholder = styled.div<{
  $height: number;
  $isFixed: boolean;
}>`
  visibility: hidden;
  height: ${({ $isFixed, $height }) => ($isFixed ? `${$height}px` : '0')};
`;

export const Header = styled.div<{ $isSelectionMode: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  height: 70px;
  ${({ $isSelectionMode }) => $isSelectionMode && SelectionHeaderStyles}

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 0 -15px;
    padding: 0 15px;
  }
`;

export const Title = styled(Typography.Header).attrs({
  $variant: '0',
})`
  font-size: 24px;
`;

export const SelectionTitle = styled(Typography.Header).attrs({
  $variant: '0',
})`
  font-size: 18px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
  }
`;

export const ActionButton = styled(Button).attrs({
  borderRadius: 14,
})`
  padding: 0 35px;
  white-space: nowrap;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 100%;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
  background: none;
  cursor: pointer;
  box-shadow: none;
  width: 16px;
  height: 16px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    path {
      fill: ${({ theme }) => theme.palette.primary.labels};
    }
  }
`;

export const MobilePrimaryActionButton = styled(Button).attrs({
  borderRadius: 14,
})`
  white-space: nowrap;
`;

export const MobileActionSheet = styled.div`
  height: 89px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ActionsWrapper = styled.div<{ $hasPriority?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $hasPriority }) =>
    $hasPriority ? '120px 1fr' : 'minmax(150px, auto) minmax(150px, auto)'};
  gap: 10px;
  justify-content: flex-end;
`;

export const MobileActionsWrapper = styled.div<{ $hasPriority?: boolean }>`
  display: grid;
  gap: 10px;
  flex: 100%;
  grid-template-columns: ${({ $hasPriority }) =>
    $hasPriority ? '120px 1fr' : '1fr 1fr'};
`;

export const SecondaryActionButton = styled(Button).attrs({
  borderRadius: 14,
})`
  color: ${({ theme }) => theme.palette.primary.labels};
  background-color: ${({ theme }) => theme.palette.secondary.background};

  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => theme.palette.tertiary.labels};
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }
`;
